import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/job/provider'

export default {
  async countAll(period, mode) {
    return await axios
      .get(endpoint + `/count?period=${period}&mode=${mode}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getAll(filter) {
    return await axios
      .get(endpoint + `/list${filter}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getDetail(reservationId) {
    return await axios
      .get(endpoint + `/detail/${reservationId}`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getPreferredVehicles(reservationId) {
    return await axios
      .get(endpoint + `/list/vehicle/${reservationId}`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getPreferredDrivers(reservationId) {
    return await axios
      .get(endpoint + `/list/driver/${reservationId}`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async confirmProvider(request) {
    return await axios
      .post(endpoint + '/provider/confirm', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async declineProvider(request) {
    return await axios
      .post(endpoint + '/provider/decline', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async assignVehicle(request) {
    return await axios
      .post(endpoint + '/vehicle/assign', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async releaseVehicle(request) {
    return await axios
      .post(endpoint + '/vehicle/release', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async manualDispatchDriver(request) {
    return await axios
      .post(endpoint + '/driver/dispatch', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async releaseDriver(request) {
    return await axios
      .post(endpoint + '/driver/release', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async addPostbookingAncillary(request) {
    return await axios
      .post(endpoint + '/provider/extraservice', request)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async updatePostbookingAncillary(request) {
    return await axios
      .put(endpoint + '/provider/extraservice', request)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async deletePostbookingAncillary(id) {
    return await axios
      .delete(endpoint + '/provider/extraservice/' + id)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async proposePrice(object) {
    return await axios
      .post(endpoint + '/provider/propose', object)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async approvePrice(object) {
    return await axios
      .post(endpoint + '/provider/approve', object)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async proposePriceReject(object) {
    return await axios
      .post(endpoint + '/provider/proposereject', object)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async repricePostbookingAncillary(object) {
    return await axios
      .post(endpoint + '/provider/price', object)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async publishInvoice(object) {
    return await axios
      .post(endpoint + '/provider/invoice', object)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async closeReservation(object) {
    return await axios
      .post(endpoint + '/provider/close', object)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async rescueReservation(object) {
    return await axios
      .post(endpoint + '/provider/rescue', object)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async viewAttachment(id) {
    return await axios
      .get(endpoint + `/provider/attach/${id}`)
      .then(response => {
        return response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/job/providerJob/inquiryProviderJobService.js